module.exports = __webpack_public_path__ + "img/medal-point-pink.b734fad3.svg";